var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoschmannOrganisch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.84,
    height: 138.02,
    viewBox: "0 0 163.84 138.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.65,8.83c-18.2,11.42-29.18,32.46-48.73,41.47-5.32,2.45-11.07,3.89-16.42,6.27C10.82,63.09-.51,77.87.02,93.69c.53,15.82,15,30.74,31.05,29.55,4.37-.32,8.67-1.71,13.03-1.37,7,.55,12.76,5.34,18.8,8.85,16.36,9.49,37.84,9.74,54.43.64,8.68-4.76,16.15-12.16,19.45-21.37,2.26-6.3,2.5-13.1,3.87-19.64,4.6-22.03,21.82-40.67,23.14-63.13,2.01-34.16-53.03-31.01-73.14-18.39",
    fill: "#ea8264"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoschmannOrganisch);
export default __webpack_public_path__ + "static/media/poschmann_organisch.260c8c2892747d7176008f4cb066570e.svg";
export { ForwardRef as ReactComponent };